import React from 'react';
import { Tabs, Button } from 'antd';
import { FiArrowLeft, FiRefreshCw } from 'react-icons/fi';
import { DAG_TASK_DETAIL_TAB, DAG_TASK_DETAIL_TABS } from '../constants';
import { TaskHeader } from './task-header';
import { OverviewTab } from './overview-tab';
import { TaskInstancesTab } from './task-instances-tab';
import { useDagTaskDetail } from './use-dag-task-detail';
import styles from '../styles.module.scss';

const { TabPane } = Tabs;

/*
 * DAG-task detail screen — a task definition's performance overview, instance history, and audit log
 */
export function AirflowDagTaskDetailScreen() {
    const { dagId, taskId, task, isLoadingTask, refreshKey, activeTab, handleTabChange, handleRefresh, handleBack, handleDagClick, handleRunsClick } = useDagTaskDetail();

    return (
        <div className={`${styles.page} airflowDashboardRoot`}>
            <div className={styles.breadcrumb}>
                <span className={styles.breadcrumbLink} onClick={handleBack}>
                    <FiArrowLeft /> Back to Tasks
                </span>
                <Button size="small" onClick={handleRefresh}>
                    <FiRefreshCw />
                </Button>
            </div>
            <TaskHeader dagId={dagId} taskId={taskId} task={task} isLoading={isLoadingTask} onDagClick={handleDagClick} onRunsClick={handleRunsClick} />
            <Tabs activeKey={activeTab} onChange={handleTabChange}>
                {DAG_TASK_DETAIL_TABS.map((tab) => (
                    <TabPane tab={tab.label} key={tab.value}>
                        {tab.value === DAG_TASK_DETAIL_TAB.overview && <OverviewTab dagId={dagId} taskId={taskId} refreshKey={refreshKey} />}
                        {tab.value === DAG_TASK_DETAIL_TAB.taskInstances && <TaskInstancesTab dagId={dagId} taskId={taskId} refreshKey={refreshKey} />}
                    </TabPane>
                ))}
            </Tabs>
        </div>
    );
}
